/**
 * Formats a phone number string using a given format string.
 * @param format The format string to use for formatting the phone number.
 *  Use "#" to indicate where digits from the phone number should be inserted.
 *  Use "-" to include hyphens in the formatted number.
 * @param phoneNumber The phone number string to format.
 * @returns The formatted phone number string.
 */
function formatPhoneNumber(format: string, phoneNumber: string): string {
  if (phoneNumber?.length < format?.split('#').length - 1) {
    return '';
  }
  let formattedNumber = '';
  let phoneNumberIndex = 0;
  for (let i = 0; i < format.length; i++) {
    if (format[i] === '#') {
      formattedNumber += phoneNumber[phoneNumberIndex];
      phoneNumberIndex++;
    } else {
      formattedNumber += format[i];
    }
  }
  return formattedNumber;
}

/**
 * Prepares a Sitecore phone string for a tel: href.
 * Keeps the authored number format (+, digits, hyphens, spaces, dots, parentheses)
 * and removes letters / notes such as "(U.S. Only)", which iOS maps to extra dial-pad digits.
 * Returns an empty string when nothing is dialable.
 */
export function toDialablePhoneNumber(phone?: string | null): string {
  if (phone == null) return '';

  let value = phone.trim();
  if (!value) return '';

  // Drop notes like "(U.S. Only)" that contain letters.
  value = value.replace(/\([^()]*[a-zA-Z][^()]*\)/g, '');
  // Drop remaining letters (e.g. "Call").
  value = value.replace(/[a-zA-Z]/g, '');
  // Keep only characters that belong in a formatted phone number.
  value = value.replace(/[^\d+().\-\s]/g, '');
  value = value.replace(/\(\s*\)/g, '');
  value = value.replace(/^[.\-\s]+|[.\-\s]+$/g, '');
  value = value.replace(/\s+/g, ' ').trim();

  const digits = value.replace(/\D/g, '');
  if (!digits) return '';

  return value;
}

export default formatPhoneNumber;
